import * as React from 'react';

import { NewbuildingSpecialProject } from './NewbuildingSpecialProject';
import { INewbuildingSpecialProjectBannerContext } from '../../../../../../types/adfox';
import { useAdfoxContext } from 'shared/utils/AdfoxContext';

export interface INewbuildingSpecialProjectContainerProps {
  context: INewbuildingSpecialProjectBannerContext;
}

export function NewbuildingSpecialProjectContainer({ context }: INewbuildingSpecialProjectContainerProps) {
  const { sizes } = useAdfoxContext();

  return <NewbuildingSpecialProject context={context} sizes={sizes} />;
}
